import { RootState } from '../index';

const getTasklists = (state: RootState) => state.tasklistsReducer.tasklists;

const getSelectedTasklist = (state: RootState) => state.tasklistsReducer.selectedTasklist;

const getSelectedTasklistForAction = (state: RootState) => state.tasklistsReducer.selectedTasklistForAction;

const getIsOpenDeleteDialog = (state: RootState) => state.tasklistsReducer.isOpenDeleteDialog;

const getSubmissions = (state: RootState) => state.tasklistsReducer.submissions;

const getSubmittedTasklists = (state: RootState) => state.tasklistsReducer.submittedTasklists;

const getDailySubmissions = (state: RootState) => state.tasklistsReducer.dailySubmissions;

const getSelectedSubmission = (state: RootState) => state.tasklistsReducer.selectedSubmission;

const getFormattedSubmissions = (state: RootState) => state.tasklistsReducer.formattedSubmissions;

const getSelectedDailySubmission = (state: RootState) => state.tasklistsReducer.selectedDailySubmission;

const getSelectedTasklistToSubmit = (state: RootState) => state.tasklistsReducer.selectedTasklistToSubmit;

const getSubmissionsTab = (state: RootState) => state.tasklistsReducer.tab;

const getIsOpenAllTasklistsNav = (state: RootState) => state.tasklistsReducer.isOpenAllTasklistsNav;

const getIsOpenAllSubmissionsNav = (state: RootState) => state.tasklistsReducer.isOpenAllSubmissionsNav;

const getTasklistSelectedLocationId = (state: RootState) => state.tasklistsReducer.tasklistSelectedLocationId;

export {
  getTasklists,
  getSelectedTasklist,
  getIsOpenDeleteDialog,
  getSelectedTasklistForAction,
  getSubmissions,
  getSubmittedTasklists,
  getDailySubmissions,
  getSelectedSubmission,
  getFormattedSubmissions,
  getSelectedDailySubmission,
  getSelectedTasklistToSubmit,
  getSubmissionsTab,
  getIsOpenAllTasklistsNav,
  getIsOpenAllSubmissionsNav,
  getTasklistSelectedLocationId,
};
